import { call, put, takeEvery, select } from 'redux-saga/effects'
import lodash from 'lodash'
import deepdash from 'deepdash'
import { LOG_OUT_SUCCEEDED } from '../auth/actionTypes'
import {
  FETCH_APP_CONTENT,
  FETCH_APP_CONTENT_FAILED,
  SET_APP_CONTENT_LANGUAGE,
  FETCH_FEATURE_SETTINGS,
  FETCH_FEATURE_SETTINGS_FAILED,
  FETCH_FEATURE_SETTINGS_SUCCEEDED,
  FETCH_NOTIFICATION_SETTINGS,
  FETCH_NOTIFICATION_SETTINGS_SUCCEEDED,
  FETCH_NOTIFICATION_SETTINGS_FAILED,
  POST_NOTIFICATION_SETTINGS,
  POST_NOTIFICATION_SETTINGS_SUCCEEDED,
  POST_NOTIFICATION_SETTINGS_FAILED,
} from './index'
import {
  setAppContentToState,
  setStaticAppContent,
} from './index'
import {
  setLocalStorageLanguage,
  getDefaultLanguage,
} from './appContentLanguage'
import { getUnCamelized } from '../fetch'
import appContentStatic from './appContentStatic'

import * as schema from '../schema'
import { fetchSaga } from '../sagas'
import { get, post } from '../fetch'
import { getAppNotificationSettings } from '../selectors'

const _ = deepdash(lodash)


let appContentEn = appContentStatic['en']
let appContentNo = appContentStatic['no']

export function* clearAppContent() {
  const language = getDefaultLanguage()
  appContentEn = appContentStatic['en']
  appContentNo = appContentStatic['no']

  if (language === 'en') {
    yield put(setStaticAppContent(appContentEn))
  } else {
    yield put(setStaticAppContent(appContentNo))
  }
}

function* fetchAppContent() {
  try {
    let { data, errors } = yield call(() =>
      getUnCamelized(`/app_settings/contents`),
    )

    if (errors) {
      yield put({
        type: FETCH_APP_CONTENT_FAILED,
        errors,
      })
      return null // Return null if there were errors.
    } else {
      return data.app_contents
    }
  } catch (error) {
    console.error(error)
    yield put({
      type: FETCH_APP_CONTENT_FAILED,
      errors: [{ detail: error.message }],
    })
    return null // Return null also in case of exceptions.
  }
}


function* fetchAllAppContentSaga() {
  try {
    // Setting the global variables to the retrieved data
    let appContent = yield call(fetchAppContent)
    appContentEn = appContent['en']
    appContentNo = appContent['no']
    
      if (getDefaultLanguage() === 'en') {
      yield put(setAppContentToState(appContentEn))
    } else {
      yield put(setAppContentToState(appContentNo))
    }

  } catch (error) {
    console.error(error)
    yield put({
      type: FETCH_APP_CONTENT_FAILED,
      errors: [{ detail: error.message }],
    })
  }
}

function* setLanguageSaga(action) {
  const newLanguage = action.payload
  yield setLocalStorageLanguage(newLanguage)

  if (newLanguage === 'en') {
    yield put(setAppContentToState(appContentEn))
  } else {
    yield put(setAppContentToState(appContentNo))
  }
}

function* saveAppSettings() {
  try {
    const appSettings = yield select(getAppNotificationSettings)

    const { data, errors } = yield call(() =>
      post(`/app_settings/update_notification_settings`, { ..._.omitDeep(appSettings, 'valueRef') }),
    )

    if (errors) {
      yield put({
        type: POST_NOTIFICATION_SETTINGS_FAILED,
        errors,
      })
    } else {
      yield put({
        type: POST_NOTIFICATION_SETTINGS_SUCCEEDED,
        payload: data,
      })
    }
  } catch (error) {
    console.error(error)
    yield put({
      type: POST_NOTIFICATION_SETTINGS_FAILED,
      errors: [{ detail: error.message }],
    })
  }
}

function* saga() {
  yield takeEvery(FETCH_APP_CONTENT, fetchAllAppContentSaga)
  yield takeEvery(SET_APP_CONTENT_LANGUAGE, setLanguageSaga)
  yield takeEvery(LOG_OUT_SUCCEEDED, clearAppContent)
  yield takeEvery(
    FETCH_FEATURE_SETTINGS,
    fetchSaga({
        SUCCEEDED: FETCH_FEATURE_SETTINGS_SUCCEEDED,
        FAILED: FETCH_FEATURE_SETTINGS_FAILED,
        schema: schema.featureSettingsResponse,
        fetch: () => get(`/app_settings/feature_settings`),
    }),
  )
  yield takeEvery(
      FETCH_NOTIFICATION_SETTINGS,
      fetchSaga({
        SUCCEEDED: FETCH_NOTIFICATION_SETTINGS_SUCCEEDED,
        FAILED: FETCH_NOTIFICATION_SETTINGS_FAILED,
        schema: schema.appSettingsResponse,
        fetch: () => get(`/app_settings/notification_settings`),
      }),
    )
    yield takeEvery(POST_NOTIFICATION_SETTINGS, saveAppSettings)
}

export default saga
